import { AxiosRequestConfig } from 'axios';
import { BaseApi } from '@trukt/utils/BaseApi';
import {
  OrderEndpoint,
  OrderSevices,
  NoteEndpoints,
  NoteServices,
  ReportEndpoints,
  ReportServices,
  AttachmentEndpoints,
  AttachmentServices,
  ContactEndpoints,
  ContactServices,
  ClientEndpoints,
  ClientServices,
} from './services';

class TruktApi extends BaseApi {
  order: OrderEndpoint;
  note: NoteEndpoints;
  report: ReportEndpoints;
  attachment: AttachmentEndpoints;
  contact: ContactEndpoints;
  client: ClientEndpoints;

  constructor(config: AxiosRequestConfig) {
    super(config);
    this.order = new OrderSevices(this.instance);
    this.note = new NoteServices(this.instance);
    this.report = new ReportServices(this.instance);
    this.attachment = new AttachmentServices(this.instance);
    this.contact = new ContactServices(this.instance);
    this.client = new ClientServices(this.instance);
  }
}

export const truktApi = new TruktApi({
  baseURL: process.env.TRUKT_API_BASE_URL,
});
